module.exports = __webpack_public_path__ + "static/media/reactlogo.84d44aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/reactlogo.png
// module id = 817
// module chunks = 0